import React, { FunctionComponent } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Switch } from '../../../components';
import { i18n } from '../../../helpers/i18n';
import { countMetrika } from '../../../helpers/metrika';
import { NoiseCancellationType, selectNoiseCancellationType, setNoiseCancellationTypeAction } from '../../settings';
import css from './styles.css';

export const NoiseCancellationSwitch: FunctionComponent = () => {
    const dispatch = useDispatch();

    const noiseCancellationType = useSelector(selectNoiseCancellationType);

    const isEnabled = noiseCancellationType !== NoiseCancellationType.DISABLED;

    const toggleNoiseCancellation = () => {
        const type = isEnabled ? NoiseCancellationType.DISABLED : NoiseCancellationType.AUTO;
        countMetrika('meeting_screen', 'noise_cancellation', 'user', type);
        dispatch(setNoiseCancellationTypeAction(type));
    };

    return (
        <Switch
            className={css.switch}
            size="sm"
            labelBefore={i18n('settings', 'noise-cancellation-title')}
            checked={isEnabled}
            onChange={toggleNoiseCancellation}
            stretch
            shrink
        />
    );
};
